export const Name = "poll";
